module.exports = __webpack_public_path__ + "static/1gde-ede4e4c3150a1daa9304cb946ff9982e.gif";